import { useLayoutEffect } from 'react'
import { useThree } from '@react-three/fiber'

import useSettings from '@/webgl/hooks/useSettings'
import { getSizeFromMaxPixelCount } from '@/webgl/utils'

const Resizer = () => {
  const { get } = useThree()
  const { dpr } = useSettings()

  useLayoutEffect(() => {
    const resize = () => {
      const size = get().size
      const { width } = getSizeFromMaxPixelCount(size.width, size.height, dpr)
      /**
       * meglio limitare la dimensione del canvas modificando i dpr.
       * settare la dimensione in px va in conflitto con il resize interno di fiber
       * in questo caso posso fare così perché non era previsto già in partenza che i dpr fossero main > 0
       */
      get().setDpr(width / size.width)
      // get().setSize(width, height, false)
    }

    window.addEventListener('resize', resize)

    resize()

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [dpr, get])

  return null
}

export default Resizer
